import ISlideMaster from '@app/types/presentations/master/ISlideMaster';
import IDummySlideData from '@app/types/data/slides/IDummySlideData';
import AbstractSlideTransform from './AbstractSlideTransform';

/**
 * Dummy slide transform
 */
export default class DummySlideTransform extends AbstractSlideTransform {
	public viewComponent: string = 'DummySlide';

	public async transform(slide: ISlideMaster): Promise<IDummySlideData> {
		return {
			id: slide.id,
			label: slide.type,
			thumbnail: this.extractThumbnail(slide.type, slide, 'image', 'backgroundImage'),
			headline: `${slide.type} ${slide.id}`
		};
	}
}
